import headerItems from "../../assets/images/header-items-1.png";
import headerItemsEng from "../../assets/images/header-items-eng.png";

const Header = (props) => {
  return (
    <section className="w-full pt-32 bg-[url(../../assets/images/header-bg.png)] flex justify-center bg-cover bg-top">
      <div className="w-2/3 md:w-1/2 flex flex-col items-center">
        <img
          src={props.currentLang === "eng" ? headerItemsEng : headerItems}
          alt="Knorla"
          className="w-full max-w-screen-lg"
        />

        <a href={props.currentLang === "eng" ? "/#register" : "/#kayit-ol"}>
          <p className="text-md lg:text-3xl font-bold text-green-custom w-min hover:text-yellow-400 bg-white px-6 2xl:px-11 py-1 rounded-md whitespace-nowrap">
            {props.currentLang === "eng" ? "REGISTER" : "KAYIT OL"}
          </p>
        </a>
      </div>
    </section>
  );
};

export default Header;
